import { takeLatest, put } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import * as api from 'data/api';
import { actions } from './slice';
import { transformPayout, transformPayoutConfiguration } from './transformers';
export function* getPayout(_ref) {
  let {
    payload: {
      userId,
      payoutId
    }
  } = _ref;
  const response = yield* call(api.getPayout, userId, payoutId);

  if ('errors' in response) {
    yield put(actions.getPayoutFailure());
    return;
  }

  yield put(actions.getPayoutSuccess({
    payout: transformPayout(response.payout)
  }));
}
export function* getPayoutConfiguration(_ref2) {
  let {
    payload: {
      userId
    }
  } = _ref2;
  const response = yield* call(api.getPayoutConfiguration, userId);

  if ('errors' in response) {
    yield put(actions.getPayoutConfigurationFailure());
    return;
  }

  yield put(actions.getPayoutConfigurationSuccess({
    payoutConfiguration: transformPayoutConfiguration(response.payout)
  }));
}
export default function* saga() {
  yield takeLatest(actions.getPayoutRequest.type, getPayout);
  yield takeLatest(actions.getPayoutConfigurationRequest.type, getPayoutConfiguration);
}